import { Link } from "react-router-dom";

export const PurchaseCancelled = () => (
	<main className="min-h-svh bg-grayDefault flex items-center justify-center p-5 sm:p-10">
		<section aria-labelledby="checkout-cancelled-title" className="w-full max-w-xl rounded-2xl bg-white p-7 sm:p-12 shadow-sm text-center">
			<p className="text-primary font-semibold mb-3">Subscription checkout</p>
			<h1 id="checkout-cancelled-title" className="text-3xl sm:text-4xl font-bold text-gray-900">Checkout cancelled</h1>
			<p className="mt-5 text-base sm:text-lg text-graySecondary leading-relaxed">You cancelled checkout. You can return to your subscription options whenever you’re ready.</p>
			<div className="mt-8 flex flex-col gap-4">
				<Link to="/subscription" className="rounded-full bg-primary hover:bg-primaryDark text-white font-semibold px-6 py-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary">Back to subscriptions</Link>
				<Link to="/" className="rounded-full text-primary hover:text-primaryDark font-semibold px-6 py-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary">Back to app</Link>
			</div>
		</section>
	</main>
);
